<div class="max-w-6xl m-4 space-y-6">
  <ng-container *ngIf="form">
    <mat-expansion-panel [expanded]="true" id="company-panel">
      <mat-expansion-panel-header>
        <mat-panel-title>{{ isNewCompany ? 'New' : '' }} Company Details </mat-panel-title>
      </mat-expansion-panel-header>

      <div class="grid grid-cols-2 gap-4 p-4">
        <mat-form-field appearance="outline">
          <mat-label>Company Name</mat-label>
          <input matInput [formControl]="getControl('companyName')" />
          <mat-error *ngIf="showError(form, 'companyName', 'required')">Company Name is required.</mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Legal Name</mat-label>
          <input matInput [formControl]="getControl('legalName')" />
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Contact Email</mat-label>
          <input matInput [formControl]="getControl('contactEmail')" />
          <mat-error *ngIf="showError(form, 'contactEmail', 'required')">Contact Email is required.</mat-error>
          <mat-error *ngIf="showError(form, 'contactEmail', 'pattern')">Invalid email format.</mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Contact Phone</mat-label>
          <input matInput [formControl]="getControl('contactPhone')" />
          <mat-error *ngIf="showError(form, 'contactPhone', 'required')">Contact Phone is required.</mat-error>
          <mat-error *ngIf="showError(form, 'contactPhone', 'pattern')">Invalid phone format.</mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Bid Email Address</mat-label>
          <input matInput [formControl]="getControl('bidEmailAddress')" />
          <mat-error *ngIf="showError(form, 'bidEmailAddress', 'required')">Bid Email Address is required.</mat-error>
          <mat-error *ngIf="showError(form, 'bidEmailAddress', 'pattern')">Invalid email format.</mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Tax ID</mat-label>
          <input matInput [formControl]="getControl('taxId')" />
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Address Line 1</mat-label>
          <input matInput [formControl]="getControl('addressLine1')" />
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Address Line 2</mat-label>
          <input matInput [formControl]="getControl('addressLine2')" />
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>City</mat-label>
          <input matInput [formControl]="getControl('city')" />
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>State</mat-label>
          <input matInput [formControl]="getControl('state')" />
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Postal Code</mat-label>
          <input matInput [formControl]="getControl('postalCode')" />
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Country</mat-label>
          <input matInput [formControl]="getControl('country')" />
        </mat-form-field>

        <mat-radio-group class="pt-2" aria-label="Select an option" color="primary" [formControl]="getControl('isUnion')">
          <mat-radio-button class="w-1/3 pl-2" [value]="option.value" *ngFor="let option of unionOptions">{{
              option.label | titlecase
            }}</mat-radio-button>
        </mat-radio-group>
      </div>
    </mat-expansion-panel>

    <!-- Compliance -->
    <mat-expansion-panel id="compliance-panel">
      <mat-expansion-panel-header>
        <mat-panel-title> Compliances ({{ compliancesArray['controls'].length }})</mat-panel-title>
      </mat-expansion-panel-header>
      <div class="p-4 space-y-4">
        <mat-card *ngFor="let complianceGroup of compliancesArray['controls']; let i = index" [formGroup]="complianceGroup">
          <mat-card-title class="px-2">
            <div class="flex flex-row justify-between w-full">
              <label class="mt-1"
              >{{ getComplainceDocType(complianceGroup.get('docType')) }} -
                {{ complianceGroup.get('status')?.value ?? '' | titlecase }}</label
              >
              <button class="h-full mt-2 me-2" (click)="deleteCompliance(i)">
                <mat-icon>delete</mat-icon>
              </button>
            </div>
          </mat-card-title>
          <div class="flex flex-row pl-4 pb-4">
            <app-project-file-upload
              subType="installer"
              [installerId]="installerId"
              [maxFileLength]="1"
              [uploadedFiles]="getUploadedFiles(i)"
              (fileAddEmitter)="handleFileAddEmit($event, i)"
              (fileRemoveEmitter)="handleFileRemoveEmit($event, i)"
            >
            </app-project-file-upload>
            <div class="grid grid-cols-2 gap-4 p-4 items-center">
              <mat-form-field appearance="outline">
                <mat-label>Doc Type</mat-label>
                <mat-select formControlName="docType">
                  <mat-option [value]="type.value" *ngFor="let type of installerDropDownConfig.compliance">{{ type.label }}</mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>Issued Date</mat-label>
                <input matInput [matDatepicker]="datepicker" formControlName="issuedDate" />
                <mat-datepicker-toggle matIconSuffix [for]="datepicker"></mat-datepicker-toggle>
                <mat-datepicker #datepicker> </mat-datepicker>
              </mat-form-field>

              <mat-form-field *ngIf="isComplainceDocDateRequired(complianceGroup)" appearance="outline">
                <mat-label>Expired Date</mat-label>
                <input matInput [matDatepicker]="datepicker" formControlName="expiryDate" />
                <mat-datepicker-toggle matIconSuffix [for]="datepicker"></mat-datepicker-toggle>
                <mat-datepicker #datepicker> </mat-datepicker>
              </mat-form-field>
            </div>
          </div>
        </mat-card>

        <button mat-flat-button color="primary" (click)="compliancesArray.push(addCompliance())">+ Add Compliance</button>
      </div>
    </mat-expansion-panel>
    <div class="w-full pr-4 flex justify-end">
      <div>
        <button (click)="this.cancel()" class="mt-2" mat-raised-button>Cancel</button>
        <button (click)="this.save()" class="mt-2 ms-2" mat-flat-button color="primary">SAVE</button>
      </div>
    </div>
  </ng-container>
</div>
